import React from 'react';
import { useRowDensity } from '../../../../hook/useRowDensity';
import { cashRegisterTableColumn, StatsTableColumn } from '../../../../enum/TableColumn';
import { getCellClass } from '../../../../util/table-helper';
import TableCellWithTooltip from './TableCellWithTooltip';
import { VirtualItem } from '@tanstack/react-virtual';
import { t } from 'i18next';
import { formatColumnValue } from '../../../../util/formatColumnValue';

interface TableBodyProps {
  column: string;
  data: Record<string, number>[];
  selectedRow: number | null;
  onRowSelect: (rowIndex: number | null) => void;
  virtualRows: VirtualItem[];
  visibleRowsHeight: number;
}

const TableBody: React.FC<TableBodyProps> = ({
  data,
  column,
  selectedRow,
  onRowSelect,
  virtualRows,
  visibleRowsHeight,
}) => {
  const { rowDensityClass, rowDensityHeight } = useRowDensity();

  return (
    <div className="table_body" style={{ position: 'relative', height: visibleRowsHeight }}>
      {virtualRows.map((vRow) => {
        const row = data[vRow.index];
        if (!row) return null;
        const value = row[column];
        const displayValue = formatColumnValue(column, value);

        return (
          <div
            key={vRow.key}
            data-index={vRow.index}
            onClick={() => onRowSelect(selectedRow === vRow.index ? null : vRow.index)}
            className={`table_row ${column === StatsTableColumn.CCY || typeof value === 'number' ? 'text_right' : ''} ${
              column === t('cashRegister.table.header.device') &&
              typeof value === 'string' &&
              value === t('cashRegister.table.cellValue.perLocation')
                ? 'device_row orange'
                : ''
            } ${getCellClass(column, row)}  ${vRow.index % 2 === 0 ? 'row_even' : 'row_odd'}  ${
              selectedRow === vRow.index ? 'selected' : ''
            }`}
            style={{
              position: 'absolute',
              width: '100%',
              height: rowDensityHeight,
              transform: `translateY(${vRow.start}px)`,
              willChange: 'transform',
            }}
          >
            <TableCellWithTooltip
              value={displayValue}
              rowDensityClass={rowDensityClass}
              headerCell={false}
              column={column}
            />
          </div>
        );
      })}
    </div>
  );
};
export default TableBody;
